const DatosNodo=((cifras) => {
    let nota=[];
    let letrainic='';
    let idcifras='';
    const elems=Object.keys(cifras);
    elems.map((item,key) => {
        letrainic=item.substring(0,1);
        idcifras=letrainic.toUpperCase()+item.substring(1,item.length);
        nota.push(<tr><td align="left">{idcifras}</td><td></td><td align="right">{cifras[item]}</td></tr>)
    })
    return (<table><tbody>{nota}</tbody></table>);
});
export default DatosNodo;